import {
  maxDashboardWidth,
  maxHorizontalCardWidth,
  maxVerticalCardWidth
} from 'const/styles'
import styled, { css } from 'styled-components'
import query from 'syf-component-library/const/mediaQueries'
import { spacing } from 'syf-component-library/defaultTheme'
import { Inset } from 'syf-component-library/ui/spacing'
import H5 from 'syf-component-library/ui/typography/H5'

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.large}px;

  @media ${query.lessThanMedium} {
    padding-left: ${spacing.base}px;
  }
`

export const DashboardContainer = styled(Inset)`
  width: 100%;

  @media ${query.greaterThanLarge} {
    max-width: ${maxDashboardWidth}px;
  }
`

export const DashboardAccountGrid = styled.ul`
  list-style: none;
  padding: 0 0 ${spacing.large}px;
  margin: 0;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: ${spacing.small}px;

  @media ${query.greaterThanSmall} {
    gap: ${spacing.base}px;
  }

  @media ${query.greaterThanMedium} {
    gap: ${spacing.large}px;
  }
  * {
    box-sizing: border-box;
  }
`

export const ErrorContainer = styled.div`
  display: flex;
  padding: 0 0 ${spacing.large}px;
`

export const AccountManagerContainer = styled.div`
  max-width: ${maxHorizontalCardWidth}px;
  margin-bottom: ${spacing.medium}px;
  @media ${query.betweenSmallMedium} {
    margin-bottom: ${spacing.medium}px;
    max-width: ${maxVerticalCardWidth}px;
  }
`

const AccountCardMobileView = css`
  justify-items: left;
  text-align: center;
`

export const AccountManagerGrid = styled(Inset)`
  align-items: center;
  border-radius: 5px;
  display: grid;
  grid-template-columns: auto auto;
  justify-content: left;
  padding: 0;

  @media ${query.lessThanMedium} {
    ${AccountCardMobileView}
    grid-template-columns: 100%;
  }
`

export const AccountManagerText = styled(H5)`
  color: ${({ theme }) =>
    theme.brandRefreshPhase >= 1
      ? 'var(--syfds-color-content-default)'
      : theme.white};
  line-height: 28px;
`

export const MainContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: ${spacing.xlarge}px;

  @media ${query.lessThanMedium} {
    flex-direction: column-reverse;
  }
`

export const AccountsContainer = styled.div`
  flex: 2;
`
